// Eskom PARCC — loading skeleton for list refreshes.
//
// Distinct from `LoadingState`: that one covers the FIRST load (there is nothing
// on screen yet); this covers a refresh of a list already in view, where the
// handoff asks for pulsing placeholder rows rather than the content vanishing.
// Renders in both themes — Legacy gets the same bars in its own tokens.
export function Skeleton({
  rows = 6,
  label = 'Loading…',
}: {
  rows?: number;
  label?: string;
}): React.JSX.Element {
  return (
    <div role="status" aria-live="polite" aria-label={label}>
      {Array.from({ length: rows }, (_, i) => (
        <div
          key={i}
          className="lm-skel-row"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            padding: '13px 12px',
            borderBottom: '1px solid var(--line)',
            // Stagger so the rows breathe rather than blink in unison.
            animationDelay: `${i * 90}ms`,
          }}
        >
          <span
            style={{
              width: 10,
              height: 10,
              borderRadius: '50%',
              background: 'var(--surface-sunken)',
              flex: 'none',
            }}
          />
          <span style={{ flex: 1, minWidth: 0 }}>
            <span
              style={{
                display: 'block',
                height: 11,
                width: `${45 + ((i * 13) % 35)}%`,
                borderRadius: 6,
                background: 'var(--surface-sunken)',
              }}
            />
            <span
              style={{
                display: 'block',
                height: 9,
                width: `${25 + ((i * 7) % 25)}%`,
                borderRadius: 6,
                background: 'var(--surface-sunken)',
                marginTop: 7,
              }}
            />
          </span>
          <span
            style={{
              width: 74,
              height: 11,
              borderRadius: 6,
              background: 'var(--surface-sunken)',
              flex: 'none',
            }}
          />
        </div>
      ))}
    </div>
  );
}
